module.exports = __webpack_public_path__ + "media/images/gujarati-matrimony-banner-d28220cb44d8cb195c5d8e49d66ab4a3.jpg";